import axios from '../axios';
// 往来单位分组分组维护列表
export const getBasePartnerGroupPage = data => {
    return axios({
        url: '/api/sys/getBasePartnerGroupPage',
        method: 'post',
        data
    })
};
//往来单位分组列表删除
export const deleteBasePartnerGroups = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerGroups',
      method: 'post',
      data
  })
};
// 往来单位分组保存修改
export const saveBasePartnerGroup = data => {
  // 保存
  if (!data.groupId) {
    return axios({
      url: '/api/sys/saveBasePartnerGroup',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerGroup',
      method: 'post',
      data
    })
  }
}
//往来单位分组列表修改
export const updateBasePartnerGroup = data => {
  return axios({
    url: '/api/sys/updateBasePartnerGroup',
    method: 'post',
    data
  })
};
//停用/启用往来单位
export const deactivateBasePartner = data => {
  return axios({
    url: '/api/sys/deactivateBasePartner',
    method: 'post',
    data
  })
};

// 往来单位（客户）列表
export const getBasePartnerPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerPage',
      method: 'post',
      data
  })
};
// 往来单位（客户）列表删除
export const deleteBasePartners = data => {
  return axios({
      url: '/api/sys/deleteBasePartners',
      method: 'post',
      data
  })
};
//  往来单位（客户）保存修改
export const saveBasePartner = data => {
  // 保存
  return axios({
    url: '/api/sys/saveBasePartner',
    method: 'post',
    data
  })
}
//  往来单位（客户）修改
export const updateBasePartner = data => {
  // 修改
  return axios({
    url: '/api/sys/updateBasePartner',
    method: 'post',
    data
  })
}


// 客户信用额度列表
export const getBasePartnerCreditPage = data => {
  return axios({
      url: '/api/sys/base/getBasePartnerCreditPage',
      method: 'post',
      data
  })
};
// 客户信用额度列表删除
export const deleteBasePartnerCredits = data => {
  return axios({
      url: '/api/sys/base/deleteBasePartnerCredits',
      method: 'post',
      data
  })
};
// 客户信用额度列表保存修改
export const saveBasePartnerCredit = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/base/saveBasePartnerCredit',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/base/updateBasePartnerCredit',
      method: 'post',
      data
    })
  }
}
export const saveBasePartnerCreditBatch = data => {// 信用额度批量保存
  return axios({
    url: '/api/sys/base/saveBasePartnerCreditBatch',
    method: 'post',
    data
  })
}
export const updateBasePartnerCredit = data => {// 信用额度修改
  return axios({
    url: '/api/sys/base/updateBasePartnerCredit',
    method: 'post',
    data
  })
}
export const auditBasePartnerCredits = data => {// 信用额度审核.同批次才可
  return axios({
    url: '/api/sys/base/auditBasePartnerCredits',
    method: 'post',
    data
  })
}

// 单位常用联系人列表
export const getBasePartnerContactPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerContactPage',
      method: 'post',
      data
  })
};
// 单位常用联系人列表删除
export const deleteBasePartnerContacts = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerContacts',
      method: 'post',
      data
  })
};
// 单位常用联系人列表保存修改
export const saveBasePartnerContact = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerContact',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerContact',
      method: 'post',
      data
    })
  }
}

// 单位自有车辆表列表
export const getBasePartnerCarPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerCarPage',
      method: 'post',
      data
  })
};
// 单位自有车辆表删除
export const deleteBasePartnerCars = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerCars',
      method: 'post',
      data
  })
};
// 单位自有车辆表保存修改
export const saveBasePartnerCar = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerCar',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerCar',
      method: 'post',
      data
    })
  }
}


// 单位运输车辆表列表
export const getBasePartnerWxCarPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerWxCarPage',
      method: 'post',
      data
  })
};
// 单位运输车辆表列表删除
export const deleteBasePartnerWxCars = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerWxCars',
      method: 'post',
      data
  })
};
// 单位运输车辆表列表保存修改
export const saveBasePartnerWxCar = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerWxCar',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerWxCar',
      method: 'post',
      data
    })
  }
}


// 单位常用地址表列表
export const getBasePartnerAddressPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerAddressPage',
      method: 'post',
      data
  })
};
// 单位常用地址表列表删除
export const deleteBasePartnerAddresss = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerAddresss',
      method: 'post',
      data
  })
};
// 单位常用地址表列表保存修改
export const saveBasePartnerAddress = data => {
  // 保存
  if (!data.id) {
    return axios({
      url: '/api/sys/saveBasePartnerAddress',
      method: 'post',
      data
    })
  } else {
    // 修改
    return axios({
      url: '/api/sys/updateBasePartnerAddress',
      method: 'post',
      data
    })
  }
}

// 单位区域加价表列表
export const getBasePartnerAreaPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerAreaPage',
      method: 'post',
      data
  })
};
// 单位区域列表删除
export const deleteBasePartnerAreas = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerAreas',
      method: 'post',
      data
  })
};
//  单位区域批量保存
export const saveBasePartnerArea = data => {
  return axios({
    url: '/api/sys/saveBasePartnerArea',
    method: 'post',
    data
  })
}
//  单位区域修改
export const updateBasePartnerArea = data => {
  return axios({
    url: '/api/sys/updateBasePartnerArea',
    method: 'post',
    data
  })
}


// 单位项目加价表列表
export const getBasePartnerProjectPage = data => {
  return axios({
      url: '/api/sys/getBasePartnerProjectPage',
      method: 'post',
      data
  })
};
// 单位项目加价表删除
export const deleteBasePartnerProjects = data => {
  return axios({
      url: '/api/sys/deleteBasePartnerProjects',
      method: 'post',
      data
  })
};
//  单位项目加价表保存
export const saveBasePartnerProject = data => {
  return axios({
    url: '/api/sys/saveBasePartnerProject',
    method: 'post',
    data
  })
}
//  单位项目加价表修改
export const updateBasePartnerProject = data => {
  return axios({
    url: '/api/sys/updateBasePartnerProject',
    method: 'post',
    data
  })
}
// 客户价格本列表
export const getBasePricePartnerPage = (data) => {
  return axios({
    url: '/api/sys/base/getBasePricePartnerPage',
    method: 'post',
    data
  })
}
// 最新生效的客户价格本
export const inEffectBasePricePartnerPage = (data) => {
  return axios({
    url: '/api/sys/base/inEffectBasePricePartnerPage',
    method: 'post',
    data
  })
}
// 最新生效的项目价格本
export const inEffectBasePriceProjecPage = (data) => {
  return axios({
    url: '/api/sys/base/inEffectBasePriceProjecPage',
    method: 'post',
    data
  })
}
// 批量保存客户价格本
export const batchSaveBasePricePartner = (data) => {
  return axios({
    url: '/api/sys/base/batchSaveBasePricePartner',
    method: 'post',
    data
  })
}
// 批量修改客户价格本
export const updateBasePricePartnerBatch = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePricePartnerBatch',
    method: 'post',
    data
  })
}
// 批量修改_最终价格修改
export const updateBasePricePartnerFinalPriceBatch = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePricePartnerFinalPriceBatch',
    method: 'post',
    data
  })
}
// 客户价格本列表保存
export const saveBasePricePartner = (data) => {
  return axios({
    url: '/api/sys/base/saveBasePricePartner',
    method: 'post',
    data
  })
}
// 客户价格本列表修改
export const updateBasePricePartner = (data) => {
  return axios({
    url: '/api/sys/base/updateBasePricePartner',
    method: 'post',
    data
  })
}
// 客户价格本列表删除
export const deleteBasePricePartners = (data) => {
  return axios({
    url: '/api/sys/base/deleteBasePricePartners',
    method: 'post',
    data
  })
}

// 客户余额列表
export const getBasePartnerBalancePage = (data) => {
  return axios({
    url: '/api/sys/base/getBasePartnerBalancePage',
    method: 'post',
    data
  })
}
//客户余额列表删除
export const deleteBasePartnerBalances = data => {
  return axios({
      url: '/api/sys/base/deleteBasePartnerBalances',
      method: 'post',
      data
  })
};
//客户余额列表保存修改
export const saveBasePartnerBalance = data => {
  if (!data.id) {
    return axios({
        url: '/api/sys/base/saveBasePartnerBalance',
        method: 'post',
        data
    })
  } else {
    return axios({
        url: '/api/sys/base/updateBasePartnerBalance',
        method: 'post',
        data
    })
  }
};
//客户余额列表审核
export const auditBasePartnerBalances = data => {
  return axios({
      url: '/api/sys/base/auditBasePartnerBalances',
      method: 'post',
      data
  })
};


//客户销售区域列表
export const getBasePartnerSalesAreaPage = data => {
  return axios({
      url: '/api/sys/base/getBasePartnerSalesAreaPage',
      method: 'post',
      data
  })
};
//客户销售区域列表删除
export const deleteBasePartnerSalesAreas = data => {
  return axios({
      url: '/api/sys/base/deleteBasePartnerSalesAreas',
      method: 'post',
      data
  })
};
//客户销售区域列表停用/启用区域
export const deactivateBasePartnerSalesArea = data => {
  return axios({
      url: '/api/sys/base/deactivateBasePartnerSalesArea',
      method: 'post',
      data
  })
};
//禁用/启用客户项目价格
export const deactivateBasePartnerProject = data => {
  return axios({
      url: '/api/sys/deactivateBasePartnerProject',
      method: 'post',
      data
  })
};
//客户销售区域列表保存修改
export const saveBasePartnerSalesArea = data => {
  if (!data.id) {
    return axios({
        url: '/api/sys/base/saveBasePartnerSalesArea',
        method: 'post',
        data
    })
  } else {
    return axios({
        url: '/api/sys/base/updateBasePartnerSalesArea',
        method: 'post',
        data
    })
  }
};

// 客户生效价格本批量保存
export const batchSaveOfPartner = (data) => {
  return axios({
    url: '/api/sys/base/batchSaveOfPartnerHsd',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/Customer.js